import { render, staticRenderFns } from "./DeliveryManagement.vue?vue&type=template&id=debdb512&scoped=true"
import script from "./DeliveryManagement.vue?vue&type=script&lang=js"
export * from "./DeliveryManagement.vue?vue&type=script&lang=js"
import style0 from "./DeliveryManagement.vue?vue&type=style&index=0&id=debdb512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debdb512",
  null
  
)

export default component.exports